import styled from 'styled-components';

const StyledCardCarousel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
`;
const StyledControls = styled.div<{ $align: 'left' | 'center' | 'right'; $fullWidth: boolean }>`
  display: flex;
  padding: 2rem ${({ $fullWidth }) => ($fullWidth ? '0' : 'min(8rem, 10%)')};
  gap: 0.5rem;
  ${({ $align }) => $align === 'left' && 'align-self: flex-start;'}
  ${({ $align }) => $align === 'right' && 'align-self: flex-end;'}
`;

const StyledHorizontalSlider = styled.div<{ $height?: number }>`
  position: relative;
  max-width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  overflow-x: scroll;
  gap: 1.5rem;
  ${({ $height }) => $height && `height: ${$height}px;`}
  scroll-behavior: smooth;
  -webkit-scroll-behavior: smooth; /* Safari and Chrome */
  -moz-scroll-behavior: smooth; /* Firefox */
  -ms-scroll-behavior: smooth; /* Internet Explorer */
  &::-webkit-scrollbar {
    display: none;
  }
  // Hide scrollbar for Firefox
  scrollbar-width: none;
`;

const StyledCardWrapper = styled.div<{ $maxHeightPx: number }>`
  /* max-width: 30%; */
  width: auto;
  transition: all 0.3s ease-in-out;
  transition-delay: 200ms;
  max-height: ${({ $maxHeightPx }) => $maxHeightPx}px;

  & > * {
    max-height: ${({ $maxHeightPx }) => $maxHeightPx}px;
  }
`;

const StyledScrollFiller = styled.div`
  // Filler, so that the first and last card can be centered
  width: 50%;
  min-width: 40vw;
  min-height: 10px;
`;

export { StyledCardCarousel, StyledControls, StyledHorizontalSlider, StyledCardWrapper, StyledScrollFiller };
